export interface QuotaMeterProps {
  limit: number;
  remaining: number;
  window: 'min' | 'day' | 'mon';
  resetAt?: string | null;
}

/**
 * "3 מתוך 100 נותרו היום". Fed from the X-RateLimit-* response headers, which are only readable
 * cross-origin because the API sets `exposedHeaders` — without that a SPA on another subdomain
 * cannot see them at all, and this component is unbuildable.
 */
export function QuotaMeter({ limit, remaining, window, resetAt }: QuotaMeterProps) {
  const used = Math.max(0, limit - remaining);
  const label = window === 'min' ? 'בדקה זו' : window === 'mon' ? 'החודש' : 'היום';
  const low = remaining <= Math.max(1, Math.floor(limit * 0.2));
  return (
    <div data-testid="quota-meter" data-low={low ? 'true' : 'false'}>
      <progress value={used} max={limit} />
      <span>
        {remaining} מתוך {limit} נותרו {label}
      </span>
      {low && resetAt && <span> — מתאפס ב־{new Date(resetAt).toLocaleTimeString('he-IL')}</span>}
    </div>
  );
}
